import React, { useState } from "react";
import { useParams } from "react-router-dom";
import Layout from "../components/layouts/Layout";

const CaseStudiesPage = () => {
  const { id } = useParams();
  const [filterIndustry, setFilterIndustry] = useState('all');
  const [filterSolution, setFilterSolution] = useState('all');
  const [selectedIndustry, setSelectedIndustry] = useState('all');
  const [selectedCase, setSelectedCase] = useState(null);

  const caseStudies = [
    {
      id: 1,
      title: "産業機械企業でのビル空調制御アルゴリズム開発",
      company: "ファクトリーオートメーション企業（総売上120億円）",
      industry: "産業機械",
      solution: "IoT・空調制御AI",
      challenge: "センサーデータからの人の在室判別を行い、ビル空調制御の効率化が課題となっていた。従来は手動調整に依存し、電力費が高騰していた。",
      approach: "IoTプロダクトとビルマネジメント事業のソフトウェア領域を担当。熱量データ(RSSI)から人がいる/人がいないの判別を行うアルゴリズムをPythonで開発。",
      results: {
        cost: "電力費削減 30%",
        automation: "自動制御化 100%",
        accuracy: "在室判別精度 95%",
        efficiency: "運用効率 2倍向上"
      },
      testimonial: "AI導入により、ビル管理の効率化と大幅な電力費削減を実現できました。システムの信頼性も非常に高く、安心して運用できています。",
      person: "技術部長",
      timeline: "6ヶ月",
      tags: ["IoT", "空調制御", "省エネ"],
    },
    {
      id: 2,
      title: "大手太陽光発電企業でのリアルタイムデータ分析",
      company: "大手エネルギー企業",
      industry: "エネルギー",
      solution: "エネルギー予測AI",
      challenge: "太陽光発電用パワーコンディショナ・関連機器の監視・管理が人的作業に依存し、発電量予測と電力費管理に多大な工数がかかっていた。",
      approach: "Python・Javaベースのリアルタイムデータ分析システムを構築。リアルタイムで電力費と発電量を予測し、人がチェックする手間を削減。",
      results: {
        cost: "人件費削減 50%",
        automation: "監視作業自動化 100%",
        efficiency: "運用効率 3倍向上",
        accuracy: "予測精度 92%"
      },
      testimonial: "リアルタイム予測により、太陽光発電の運用が完全に変わりました。人手による監視が不要になり、収益性も大幅に向上しています。",
      person: "技術部長",
      timeline: "8ヶ月",
      tags: ["太陽光発電", "予測AI", "省人化"],
    },
    {
      id: 3,
      title: "量子技術企業での気候変動予測システム",
      company: "量子クラウド企業（時価総額397億円）",
      industry: "IT・量子技術",
      solution: "量子機械学習",
      challenge: "従来の気象予測手法では精度に限界があり、より高精度な気候変動予測システムが求められていた。",
      approach: "量子機械学習サービスのQuanvolutional Neural Networkでの概念実装を担当。気象データをAPIで取得し、ハミルトニアンを設定した上で、量子アルゴリズムで天気を予測。",
      results: {
        accuracy: "予測精度向上 6.6%",
        innovation: "最新技術導入成功",
        research: "量子ML実用化",
        efficiency: "計算効率化"
      },
      testimonial: "量子機械学習による気象予測で、従来手法を上回る精度を実現できました。最先端技術の導入により、事業の競争力が大幅に向上しています。",
      person: "CTO",
      timeline: "12ヶ月",
      tags: ["量子機械学習", "気象予測", "最先端技術"],
    },
    {
      id: 4,
      title: "大手建材メーカーでの3D建築BIMソフトウェア開発",
      company: "グローバル建材企業（総資産1.7兆円）",
      industry: "建設・建材",
      solution: "生成AI建築BIM",
      challenge: "従来のBIMソフトでは平面図・立面図の可視化と見積書作成に多大な時間を要し、生産性の向上が急務だった。",
      approach: "BIMソフトの平面図・立面図を可視化し、見積書を作成する領域を担当。ドラッグアンドドロップのユーザー体験から見積もりまでの流れを設計・開発。TypeScriptで実装。",
      results: {
        efficiency: "作業時間 62.5%削減",
        accuracy: "エラー率 80%改善",
        cost: "コスト削減 年間70万円",
        productivity: "生産性 2.5倍向上"
      },
      testimonial: "BIMソフトの導入により、設計から見積までの業務が劇的に効率化されました。視覚化機能により、顧客との合意形成も格段にスムーズになりました。",
      person: "設計部長",
      timeline: "10ヶ月",
      tags: ["BIM", "3D可視化", "建築設計"],
    },
    {
      id: 5,
      title: "大手ガス会社での経路最適化システム",
      company: "大手都市ガス企業（従業員21,159名、資本金1,321億円）",
      industry: "エネルギー・ガス",
      solution: "量子最適化AI",
      challenge: "液化天然ガス輸送における経路最適化問題で、輸送コストと熱量管理の両方を考慮した最適化が困難だった。",
      approach: "量子アニーリングによる経路最適化システムを開発。輸送とガス熱量の双方を考慮するため、距離と熱量のバッチ処理を行った。Pythonで実装。",
      results: {
        optimization: "目的関数最小化 14.3%",
        speed: "計算時間 40%短縮",
        cost: "熱量削減",
        efficiency: "運用効率向上"
      },
      testimonial: "量子最適化により、これまで不可能だったレベルの経路最適化を実現できました。エネルギー効率とコスト削減の両方で大きな成果を上げています。",
      person: "技術企画部長",
      timeline: "9ヶ月",
      tags: ["量子最適化", "経路最適化", "LNG"],
    },
    {
      id: 6,
      title: "化粧品卸企業でのSNS分析システム導入",
      company: "大手化粧品卸企業",
      industry: "小売・流通",
      solution: "SNS分析AI",
      challenge: "主要SNS（Twitter、Instagram、Facebook等）からのデータ収集・分析が手作業で、ブランド評価や消費者感情の把握が困難だった。",
      approach: "主要SNSから各種データを自動収集・統合し、ブランド評価、消費者感情、トレンド解析及び競合動向を網羅。データクレンジング、可視化、リアルタイムレポート作成機能を実装。",
      results: {
        automation: "分析作業自動化 90%",
        speed: "レポート作成時間 75%短縮",
        accuracy: "解析精度向上",
        insight: "意思決定迅速化"
      },
      testimonial: "SNS分析の自動化により、市場トレンドをリアルタイムで把握できるようになりました。マーケティング戦略の精度が格段に向上し、競争力強化に直結しています。",
      person: "マーケティング部長",
      timeline: "7ヶ月",
      tags: ["SNS分析", "マーケティング", "トレンド分析"],
    },
    {
      id: 7,
      title: "人材紹介会社でのマッチングシステム最適化（CorPia）",
      company: "人材紹介企業",
      industry: "人材・サービス",
      solution: "AIマッチングシステム",
      challenge: "従来の人材マッチングシステムでは、求職者と企業のマッチング精度が低く、手数料体系も非効率だった。",
      approach: "弊社サービス「CorPia」による人材紹介マッチングシステムを開発。設計～保守・運用までを一貫して担当。AIアルゴリズムで最適なマッチングを実現。",
      results: {
        cost: "利用手数料削減 年間2,450万円",
        matching: "マッチング精度大幅向上",
        efficiency: "紹介効率 5倍向上",
        satisfaction: "顧客満足度 95%以上"
      },
      testimonial: "CorPiaの導入により、人材マッチングの精度と効率が劇的に向上しました。年間2,450万円のコスト削減効果は予想を大きく上回る成果です。",
      person: "代表取締役",
      timeline: "6ヶ月",
      tags: ["人材マッチング", "CorPia", "コスト削減"],
    },
    {
      id: 8,
      title: "YouTube動画でのキーワード抽出システム",
      company: "デジタルマーケティング企業",
      industry: "広告・マーケティング",
      solution: "自然言語処理AI",
      challenge: "YouTube動画からの効果的なキーワード抽出が手作業で行われ、SEO対策やコンテンツマーケティング戦略の策定に時間がかかっていた。",
      approach: "LDAモデルを活用したYouTube動画のキーワード抽出システムを開発。自然言語解析により、動画内容を自動で解析・分類し、最適なキーワードを抽出。",
      results: {
        efficiency: "作業時間削減 62.5%",
        accuracy: "エラー率改善 80%",
        cost: "年間コスト削減 75万円",
        insight: "視聴者ニーズ理解向上"
      },
      testimonial: "キーワード抽出の自動化により、コンテンツマーケティングの精度が大幅に向上しました。視聴者のニーズをより深く理解できるようになりました。",
      person: "マーケティング部 部長",
      timeline: "4ヶ月",
      tags: ["自然言語処理", "YouTube", "SEO"],
    },
    {
      id: 9,
      title: "ふるさと納税最適化システム",
      company: "自治体向けシステム企業（従業員550名、売上286億円）",
      industry: "行政・自治体",
      solution: "量子最適化AI",
      challenge: "ふるさと納税制度において、利用者と自治体双方の利益を最大化する最適なマッチングシステムが求められていた。",
      approach: "ナップザック問題を使用したふるさと納税量子最適化プログラムを開発。利用者と自治体双方の利益を両立するため、量子最適化技術で納税プランの最適解を導出。",
      results: {
        optimization: "マッチング最適化",
        satisfaction: "利用者満足度向上",
        efficiency: "自治体業務効率化",
        award: "技術表彰受賞"
      },
      testimonial: "量子最適化によるふるさと納税システムで、従来にない精度でのマッチングを実現できました。表彰をいただくなど、技術面でも高い評価を得ています。",
      person: "システム開発部長",
      timeline: "8ヶ月",
      tags: ["量子最適化", "ふるさと納税", "ナップザック問題"],
    },
    {
      id: 10,
      title: "大手通信事業者での5Gコンテナ基板MANOシステム",
      company: "大手通信事業者",
      industry: "通信・インフラ",
      solution: "5G・仮想化技術",
      challenge: "5Gインフラにおけるコンテナ基板の管理・編成システムの構築が求められ、次世代通信インフラの効率的な運用が課題だった。",
      approach: "大手通信事業者向けに、5Gコンテナ基板の管理・編成（MANO）システムを構築。ネットワーク仮想化や自動化により、柔軟かつ高信頼なシステム運用を実現。",
      results: {
        virtualization: "ハードウェア仮想化実現",
        reliability: "高信頼システム運用",
        automation: "自動化による効率化",
        scalability: "スケーラブル設計"
      },
      testimonial: "5G時代に向けた基盤システムを構築できました。ネットワーク仮想化により、今後の技術進歩にも柔軟に対応できる体制が整いました。",
      person: "ネットワーク技術部長",
      timeline: "12ヶ月",
      tags: ["5G", "MANO", "仮想化"],
    }
  ];

  const industries = [
    'all',
    '産業機械',
    'エネルギー',
    'IT・量子技術',
    '建設・建材',
    'エネルギー・ガス',
    '小売・流通',
    '人材・サービス',
    '広告・マーケティング',
    '行政・自治体',
    '通信・インフラ'
  ];

  const filteredCases = selectedIndustry === 'all' 
    ? caseStudies 
    : caseStudies.filter(cs => cs.industry === selectedIndustry);

  const industryMetrics = {
    all: { cases: caseStudies.length, avgImprovement: "45%", avgTimeline: "7.8ヶ月" },
    '産業機械': { cases: 1, avgImprovement: "30%", avgTimeline: "6ヶ月" },
    'エネルギー': { cases: 1, avgImprovement: "50%", avgTimeline: "8ヶ月" },
    'IT・量子技術': { cases: 1, avgImprovement: "6.6%", avgTimeline: "12ヶ月" },
    '建設・建材': { cases: 1, avgImprovement: "62.5%", avgTimeline: "10ヶ月" },
    'エネルギー・ガス': { cases: 1, avgImprovement: "14.3%", avgTimeline: "9ヶ月" },
    '小売・流通': { cases: 1, avgImprovement: "90%", avgTimeline: "7ヶ月" },
    '人材・サービス': { cases: 1, avgImprovement: "2450万円", avgTimeline: "6ヶ月" },
    '広告・マーケティング': { cases: 1, avgImprovement: "62.5%", avgTimeline: "4ヶ月" },
    '行政・自治体': { cases: 1, avgImprovement: "最適化", avgTimeline: "8ヶ月" },
    '通信・インフラ': { cases: 1, avgImprovement: "仮想化", avgTimeline: "12ヶ月" }
  };

  // 個別事例詳細表示
  if (id) {
    const caseStudy = caseStudies.find(c => c.id === parseInt(id));
    if (!caseStudy) return <div>事例が見つかりません</div>;

    return (
      <Layout 
        title={caseStudy.title} 
        subtitle={`${caseStudy.company} - ${caseStudy.industry}での導入事例`}
      >
        <section style={{ padding: '80px 0', backgroundColor: '#1e293b' }}>
          <div className="container">
            <div className="row">
              <div className="col-md-8">
                {/* 事例詳細 */}
                <div className="premium-card" style={{ 
                  padding: '40px',
                  marginBottom: '30px',
                  background: 'rgba(30, 41, 59, 0.8)',
                  border: '1px solid rgba(59, 130, 246, 0.2)',
                  borderRadius: '12px'
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', marginBottom: '30px' }}>
                    <div style={{ fontSize: '64px', marginRight: '20px' }}>{caseStudy.image}</div>
                    <div>
                      <h2 style={{ color: '#3b82f6', marginBottom: '10px' }}>{caseStudy.title}</h2>
                      <div style={{ display: 'flex', gap: '15px' }}>
                        <span style={{ 
                          background: '#1e40af', 
                          color: 'white', 
                          padding: '4px 12px', 
                          borderRadius: '20px',
                          fontSize: '12px'
                        }}>
                          {caseStudy.industry}
                        </span>
                        <span style={{ 
                          background: '#059669', 
                          color: 'white', 
                          padding: '4px 12px', 
                          borderRadius: '20px',
                          fontSize: '12px'
                        }}>
                          {caseStudy.solution}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div style={{ marginBottom: '30px' }}>
                    <h4 style={{ color: '#f59e0b', marginBottom: '15px' }}>🚨 課題</h4>
                    <p style={{ color: '#cbd5e1' }}>{caseStudy.challenge}</p>
                  </div>

                  <div style={{ marginBottom: '30px' }}>
                    <h4 style={{ color: '#3b82f6', marginBottom: '15px' }}>💡 アプローチ</h4>
                    <p style={{ color: '#cbd5e1' }}>{caseStudy.approach}</p>
                  </div>

                  <div style={{ marginBottom: '30px' }}>
                    <h4 style={{ color: '#10b981', marginBottom: '20px' }}>成果</h4>
                    <div className="row">
                      {Object.entries(caseStudy.results).map(([key, value], index) => (
                        <div key={index} className="col-md-6" style={{ marginBottom: '15px' }}>
                          <div style={{ 
                            background: 'rgba(16, 185, 129, 0.1)',
                            padding: '15px',
                            borderRadius: '8px',
                            textAlign: 'center'
                          }}>
                            <div style={{ color: '#10b981', fontWeight: 'bold', fontSize: '18px' }}>
                              {value}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div style={{ 
                    background: 'rgba(59, 130, 246, 0.1)',
                    padding: '25px',
                    borderRadius: '12px',
                    borderLeft: '4px solid #3b82f6'
                  }}>
                    <h5 style={{ color: '#3b82f6', marginBottom: '15px' }}>💬 お客様の声</h5>
                    <p style={{ color: '#cbd5e1', fontSize: '16px', marginBottom: '15px', fontStyle: 'italic' }}>
                      "{caseStudy.testimonial}"
                    </p>
                    <p style={{ color: '#94a3b8', fontSize: '14px', textAlign: 'right', margin: 0 }}>
                      - {caseStudy.person}
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-4">
                {/* サイドバー情報 */}
                <div className="premium-card" style={{ 
                  padding: '30px',
                  marginBottom: '20px',
                  background: 'rgba(30, 41, 59, 0.8)',
                  border: '1px solid rgba(59, 130, 246, 0.2)',
                  borderRadius: '12px'
                }}>
                  <h4 style={{ color: '#f1f5f9', marginBottom: '20px' }}>📋 プロジェクト詳細</h4>
                  <div style={{ marginBottom: '15px' }}>
                    <strong style={{ color: '#cbd5e1' }}>導入期間:</strong>
                    <p style={{ color: '#94a3b8', margin: '5px 0' }}>{caseStudy.timeline}</p>
                  </div>
                  <div style={{ marginBottom: '15px' }}>
                    <strong style={{ color: '#cbd5e1' }}>タグ:</strong>
                    <div style={{ marginTop: '8px' }}>
                      {caseStudy.tags.map((tag, index) => (
                        <span key={index} style={{ 
                          background: 'rgba(59, 130, 246, 0.2)',
                          color: '#3b82f6',
                          padding: '4px 8px',
                          borderRadius: '12px',
                          fontSize: '12px',
                          marginRight: '8px',
                          marginBottom: '8px',
                          display: 'inline-block'
                        }}>
                          {tag}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>

                {/* 関連ソリューション */}
                <div className="premium-card" style={{ 
                  padding: '30px',
                  background: 'rgba(30, 41, 59, 0.8)',
                  border: '1px solid rgba(59, 130, 246, 0.2)',
                  borderRadius: '12px'
                }}>
                  <h4 style={{ color: '#f1f5f9', marginBottom: '20px' }}>🔗 関連ソリューション</h4>
                  <a href="/solutions" style={{ color: '#3b82f6', textDecoration: 'none' }}>
                    <div style={{ 
                      padding: '15px',
                      border: '1px solid rgba(59, 130, 246, 0.3)',
                      borderRadius: '8px',
                      marginBottom: '10px',
                      transition: 'all 0.2s'
                    }}>
                      {caseStudy.solution}の詳細を見る →
                    </div>
                  </a>
                  <a href="/contact/materials" className="btn btn-custom btn-sm" style={{ width: '100%' }}>
                    📄 詳細資料を請求
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </Layout>
    );
  }

  // 事例一覧表示
  return (
    <Layout 
      title="導入事例" 
      subtitle="様々な業界で実現したAI活用の成功事例と、具体的な成果をご紹介します"
    >
      {/* ヒーローセクション */}
      <section style={{ 
        padding: '65px 0 80px',
        background: 'linear-gradient(135deg, #1e40af 0%, #1d4ed8 50%, #3b82f6 100%)',
        position: 'relative'
      }}>
        <div className="container">
          <div className="row">
            <div className="col-md-8 col-md-offset-2" style={{ textAlign: 'center' }}>
              {/* 全体統計 */}
              <div style={{ 
                display: 'flex', 
                justifyContent: 'center', 
                gap: '40px', 
                flexWrap: 'wrap',
                marginTop: '40px'
              }}>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: '36px', fontWeight: '700', color: 'white' }}>50+</div>
                  <div style={{ color: 'rgba(255, 255, 255, 0.8)' }}>導入実績</div>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: '36px', fontWeight: '700', color: 'white' }}>95%</div>
                  <div style={{ color: 'rgba(255, 255, 255, 0.8)' }}>顧客満足度</div>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: '36px', fontWeight: '700', color: 'white' }}>45%</div>
                  <div style={{ color: 'rgba(255, 255, 255, 0.8)' }}>平均効率向上</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* フィルター */}
      <section style={{ padding: '60px 0 40px', backgroundColor: '#0f172a' }}>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div style={{ textAlign: 'center', marginBottom: '40px' }}>
                <h3 style={{ color: '#f1f5f9', marginBottom: '20px' }}>業界別事例</h3>
                <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '10px' }}>
                  {industries.map((industry) => (
                    <button
                      key={industry}
                      onClick={() => setSelectedIndustry(industry)}
                      style={{
                        padding: '8px 20px',
                        borderRadius: '25px',
                        border: '1px solid rgba(59, 130, 246, 0.3)',
                        background: selectedIndustry === industry ? '#3b82f6' : 'transparent',
                        color: selectedIndustry === industry ? 'white' : '#cbd5e1',
                        cursor: 'pointer',
                        transition: 'all 0.3s'
                      }}
                    >
                      {industry === 'all' ? '全業界' : industry}
                    </button>
                  ))}
                </div>
              </div>

              {/* 選択された業界の統計 */}
              <div style={{ 
                background: 'rgba(30, 41, 59, 0.8)',
                border: '1px solid rgba(59, 130, 246, 0.2)',
                borderRadius: '12px',
                padding: '30px',
                textAlign: 'center'
              }}>
                <div style={{ display: 'flex', justifyContent: 'center', gap: '60px', flexWrap: 'wrap' }}>
                  <div>
                    <div style={{ fontSize: '24px', fontWeight: '600', color: '#3b82f6' }}>
                      {industryMetrics[selectedIndustry]?.cases}件
                    </div>
                    <div style={{ color: '#94a3b8' }}>導入事例</div>
                  </div>
                  <div>
                    <div style={{ fontSize: '24px', fontWeight: '600', color: '#3b82f6' }}>
                      {industryMetrics[selectedIndustry]?.avgImprovement}
                    </div>
                    <div style={{ color: '#94a3b8' }}>平均改善率</div>
                  </div>
                  <div>
                    <div style={{ fontSize: '24px', fontWeight: '600', color: '#3b82f6' }}>
                      {industryMetrics[selectedIndustry]?.avgTimeline}
                    </div>
                    <div style={{ color: '#94a3b8' }}>平均導入期間</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 事例一覧 */}
      <section style={{ padding: '60px 0', backgroundColor: '#1e293b' }}>
        <div className="container">
          <div className="row">
            {filteredCases.map((caseStudy) => (
              <div key={caseStudy.id} className="col-md-6" style={{ marginBottom: '40px' }}>
                <div 
                  style={{ 
                    padding: '30px',
                    background: 'rgba(30, 41, 59, 0.8)',
                    border: '1px solid rgba(59, 130, 246, 0.2)',
                    borderRadius: '12px',
                    cursor: 'pointer',
                    transition: 'all 0.3s'
                  }}
                  onClick={() => setSelectedCase(caseStudy)}
                >
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '20px' }}>
                    <div style={{ display: 'flex', gap: '8px' }}>
                      <span style={{ 
                        background: '#1e40af', 
                        color: 'white', 
                        padding: '4px 12px', 
                        borderRadius: '20px',
                        fontSize: '12px'
                      }}>
                        {caseStudy.industry}
                      </span>
                      <span style={{ 
                        background: 'rgba(34, 197, 94, 0.2)',
                        color: '#22c55e',
                        padding: '4px 12px',
                        borderRadius: '20px',
                        fontSize: '12px'
                      }}>
                        {caseStudy.timeline}
                      </span>
                    </div>
                  </div>

                  <h3 style={{ color: '#f1f5f9', marginBottom: '15px', fontSize: '18px' }}>
                    {caseStudy.title}
                  </h3>

                  <p style={{ color: '#94a3b8', marginBottom: '20px', fontSize: '14px' }}>
                    {caseStudy.challenge.substring(0, 100)}...
                  </p>

                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginBottom: '20px' }}>
                    {caseStudy.tags.map((tag, index) => (
                      <span key={index} style={{ 
                        background: 'rgba(59, 130, 246, 0.2)',
                        color: '#3b82f6',
                        padding: '2px 8px',
                        borderRadius: '12px',
                        fontSize: '11px'
                      }}>
                        #{tag}
                      </span>
                    ))}
                  </div>

                  <div style={{ 
                    display: 'flex', 
                    justifyContent: 'space-between', 
                    alignItems: 'center',
                    borderTop: '1px solid rgba(59, 130, 246, 0.2)',
                    paddingTop: '15px'
                  }}>
                    <span style={{ color: '#94a3b8', fontSize: '13px' }}>
                      {caseStudy.company}
                    </span>
                    <span style={{ color: '#3b82f6', fontSize: '14px' }}>
                      詳細を見る →
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section style={{ 
        padding: '80px 0',
        background: 'linear-gradient(135deg, #1e40af 0%, #1d4ed8 50%, #3b82f6 100%)',
        textAlign: 'center'
      }}>
        <div className="container">
          <div className="row">
            <div className="col-md-8 col-md-offset-2">
              <h2 style={{ color: 'white', marginBottom: '20px' }}>
                あなたの会社も成功事例を作りませんか？
              </h2>
              <p style={{ color: 'rgba(255, 255, 255, 0.9)', marginBottom: '30px', fontSize: '18px' }}>
                業界の課題に合わせたAIソリューションで、<br />
                ビジネスの成長と効率化を実現します。
              </p>
              <a href="/contact" className="btn btn-custom btn-lg" style={{ 
                background: 'rgba(255, 255, 255, 0.2)',
                border: '2px solid white',
                color: 'white'
              }}>
                無料相談を申し込む
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* 詳細モーダル */}
      {selectedCase && (
        <div style={{ 
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0, 0, 0, 0.8)',
          zIndex: 9999,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '20px'
        }} onClick={() => setSelectedCase(null)}>
          <div style={{ 
            background: '#1e293b',
            borderRadius: '12px',
            padding: '40px',
            maxWidth: '900px',
            width: '100%',
            maxHeight: '80vh',
            overflow: 'auto',
            border: '1px solid rgba(59, 130, 246, 0.2)'
          }} onClick={(e) => e.stopPropagation()}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '30px' }}>
              <div>
                <h2 style={{ color: '#f1f5f9', marginBottom: '10px' }}>{selectedCase.title}</h2>
                <p style={{ color: '#94a3b8' }}>{selectedCase.company} | {selectedCase.industry}</p>
              </div>
              <button 
                onClick={() => setSelectedCase(null)}
                style={{ 
                  background: 'none',
                  border: 'none',
                  color: '#94a3b8',
                  fontSize: '24px',
                  cursor: 'pointer'
                }}
              >
                ×
              </button>
            </div>

            <div style={{ marginBottom: '30px' }}>
              <h4 style={{ color: '#3b82f6', marginBottom: '15px' }}>課題</h4>
              <p style={{ color: '#cbd5e1', lineHeight: '1.6' }}>{selectedCase.challenge}</p>
            </div>

            <div style={{ marginBottom: '30px' }}>
              <h4 style={{ color: '#3b82f6', marginBottom: '15px' }}>アプローチ</h4>
              <p style={{ color: '#cbd5e1', lineHeight: '1.6' }}>{selectedCase.approach}</p>
            </div>

            <div style={{ marginBottom: '30px' }}>
              <h4 style={{ color: '#3b82f6', marginBottom: '15px' }}>成果</h4>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '15px' }}>
                {Object.entries(selectedCase.results).map(([key, value]) => (
                  <div key={key} style={{ 
                    background: 'rgba(59, 130, 246, 0.1)',
                    padding: '15px',
                    borderRadius: '8px',
                    textAlign: 'center'
                  }}>
                    <div style={{ color: '#3b82f6', fontSize: '18px', fontWeight: '600' }}>{value}</div>
                    <div style={{ color: '#94a3b8', fontSize: '14px' }}>{key}</div>
                  </div>
                ))}
              </div>
            </div>

            <div style={{ marginBottom: '30px' }}>
              <h4 style={{ color: '#3b82f6', marginBottom: '15px' }}>お客様の声</h4>
              <blockquote style={{ 
                background: 'rgba(30, 41, 59, 0.8)',
                padding: '20px',
                borderLeft: '4px solid #3b82f6',
                borderRadius: '8px',
                margin: 0
              }}>
                <p style={{ color: '#cbd5e1', fontStyle: 'italic', marginBottom: '10px' }}>
                  "{selectedCase.testimonial}"
                </p>
                <cite style={{ color: '#94a3b8', fontSize: '14px' }}>— {selectedCase.person}</cite>
              </blockquote>
            </div>

            <div style={{ textAlign: 'center' }}>
              <a href="/contact" className="btn btn-custom btn-lg">
                類似プロジェクトを相談する
              </a>
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
};

export default CaseStudiesPage; 